import classnames from 'classnames/bind'
import SaleProductCard from './SaleProductCard'
import styles from './style.module.scss'
import { IScheduledProductInfo } from '@/types/mall'

const cx = classnames.bind(styles)

type Product = {
  id: string
  name: string
  imageUrl: string
  originalPrice: number
  minOrigPrice: number
  minPrice: number
  minLivePrice: number
  discount?: string
}

interface ISaleProductListProps {
  products: IScheduledProductInfo[]
}

const formatProduct = (products: IScheduledProductInfo[]): Product[] => {
  return products.map((product) => ({
    id: String(product.productInfo.productId),
    name: product.productInfo.productName,
    imageUrl: product.productInfo.images[0],
    originalPrice: product.productInfo.origPrice,
    minOrigPrice: product.productInfo.minOrigPrice,
    minPrice: product.productInfo.minPrice,
    minLivePrice: product.productInfo.minLivePrice,
  }))
}

const SaleProductList = ({ products }: ISaleProductListProps) => {
  const formattedProducts = formatProduct(products)
  const subProducts = formattedProducts.slice(0, 8)

  return (
    <div className={cx('sale-product-list')}>
      {subProducts.length > 0 && (
        <div className={cx('sub-products-grid')}>
          {subProducts.map((product) => (
            <SaleProductCard key={product.id} product={product} />
          ))}
        </div>
      )}
    </div>
  )
}

export default SaleProductList
